import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import DynamicWidthLabelInput from './DynamicWidthLabelInput';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FIRST_NAME_PROPERTY = 'firstname';
const LAST_NAME_PROPERTY = 'lastname';
const LAST_NAME_MIN_INLINE_SIZE = '50px';
const APPROXIMATE_SPACE_INLINE_SIZE = '6px';
const FIRST_NAME_MAX_INLINE_SIZE = `calc(100% - ${LAST_NAME_MIN_INLINE_SIZE} - ${APPROXIMATE_SPACE_INLINE_SIZE})`;
const ContactLabel = ({
  isEditable
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "start",
    children: [/*#__PURE__*/_jsx(Box, {
      overflow: "hidden",
      shrink: 0,
      maxInlineSize: FIRST_NAME_MAX_INLINE_SIZE,
      children: /*#__PURE__*/_jsx(DynamicWidthLabelInput, {
        propertyName: FIRST_NAME_PROPERTY,
        isEditable: isEditable
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "heading-300",
      children: "\xA0"
    }), /*#__PURE__*/_jsx(Box, {
      overflow: "hidden",
      minInlineSize: LAST_NAME_MIN_INLINE_SIZE,
      children: /*#__PURE__*/_jsx(DynamicWidthLabelInput, {
        propertyName: LAST_NAME_PROPERTY,
        isEditable: isEditable
      })
    })]
  });
};
export default ContactLabel;